// Puerto de packages/hce/src/i18n/index.ts — mismo criterio: un solo locale
// fijo (es-EC), sin selector de idioma.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es.json';

void i18n.use(initReactI18next).init({
  resources: { es: { translation: es } },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
